<!--
  - Copyright Huesik (c) 2019.
  -->

<template>
  <modal :name="modalName" :height="'auto'" :width="width" :resizable="true" v-if="width">
    <div class="modal-container">
      <div class="modal-header flex align-center" v-if="hasHeaderSlot()">
        <slot name="header"></slot>
        <span class="close-btn" @click="closeModal"></span>
      </div>
      <div class="modal-contents">
        <slot name="contents"></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ModalLayout',
    props: {
      modalName: {
        type: String,
        default: ''
      },
      width: {
        type: [Number, String],
        default: 500
      }
    },
    methods: {
      closeModal () {
        this.$modal.hide(this.modalName)
      },
      hasHeaderSlot () {
        return !!this.$slots['header']
      }
    }
  }
</script>

<style scoped lang="less">
  .modal-container {
    padding: 2rem 0;

    .modal-header {
      padding: 2rem 4rem;
      justify-content: space-between;
      font-size: 3rem;
      color: #424242;
      border-bottom: 1px solid #eeeeee;

      .close-btn {
        padding: 2rem;
        background: url('../../assets/images/exit.png') no-repeat center;
      }
    }
    .modal-contents {
      padding: 2.3rem 4rem;
      border-bottom: 1px solid #eeeeee;
    }
    .modal-footer {
      padding: 2rem 4rem 0;
    }
  }
</style>

<style scoped lang="less">
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    .modal-container {
      padding: 2rem 0;

      .modal-header {
        padding: 1rem 2rem;
        justify-content: space-between;
        font-size: 2rem;
        color: #424242;
        border-bottom: 1px solid #eeeeee;

        .close-btn {
          padding: 1rem;
          background: url('../../assets/images/exit.png') no-repeat center;
        }
      }

      .modal-contents {
        padding: 1.3rem 2rem;
        border-bottom: 1px solid #eeeeee;
      }

      .modal-footer {
        padding: 1rem 2rem 0;
      }
    }
  }
</style>
